import React from "react";

import { parseURL } from '../../../../../common/utility/link';
import { escapeRegex } from '../../../../../common/utility/regex';
import Icon from "./Icon";

function renderHighlightedTitle(title, keyword) {
  const rawTitle = String(title || '');
  if (!keyword) {
    return rawTitle;
  }

  const reg = new RegExp(escapeRegex(keyword), 'gi');
  const parts = rawTitle.split(reg);
  const matches = rawTitle.match(reg) || [];
  const nodes = [];

  for (let i = 0; i < parts.length; i++) {
    if (parts[i]) {
      nodes.push(parts[i]);
    }
    if (matches[i]) {
      nodes.push(<strong key={`${rawTitle}-${i}`}>{matches[i]}</strong>);
    }
  }

  return nodes;
}

function Item({ setSequence, item, selected, router, keyword, onClick }) {
  const title = renderHighlightedTitle(item.title, keyword);

  if (item.type === 'url') {
    let target = '_blank';
    if (item.content.startsWith("#!")) {
      target = '_self';
    }
    if (item.config && item.config.target) {
      target = item.config.target;
    }

    return (
      <a className="doc-header__item" href={item.content} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>
        <span>{title}</span>
        <Icon className="doc-header__item-arrow" type={target === '_blank' ? 'arrow-up-right' : 'arrow'} />
      </a>
    )
  }

  if (item.type === 'file') {
    return (
      <a className="doc-header__item" href={parseURL(item.content, config.location)} target="_blank"  rel="noopener noreferrer">
        <span>{title}</span>
        <Icon className="doc-header__item-arrow" type="arrow-up-right" />
      </a>
    )
  }

  if (!item.type || item.alternative) {
    return (
      <span onClick={() => setSequence(`${item.sequence}.0`)} className="doc-header__item" >
        <span>{title}</span>
        <Icon className="doc-header__item-arrow" type="chevron" />
      </span>
    )
  }

  return (
    <a
      className={`doc-header__item ${item.sequence === selected.sequence ? 'active' : ''}`}
      href={router.generateLink(item.url)}
      onClick={(event) => {
        if (router.mode === 'history') {
          event.preventDefault();
          router.queryString = item.url;
        }
        if (onClick) onClick();
      }}
    >
      {item.config && item.config.icon && <i className={`doc-header__item-icon doc-header__item-icon--${item.config.icon}`} />}
      <span>{title}</span>
    </a>
  );
}

export default Item;
